import { StoreProps } from '../store/hypotheses-filter'

const selectValues = (state: StoreProps) => state.values
const selectStringValues = (state: StoreProps) => state.stringValues
const selectSetValues = (state: StoreProps) => state.setValues
const selectClearValues = (state: StoreProps) => state.clearValues

const selectors = {
  selectValues,
  selectClearValues,
  selectStringValues,
  selectSetValues,
}

export default selectors
